import home from './src/home.vue'
import SmartTrashManagerView from './src/SmartTrashManager/SmartTrashManagerView.vue' //智慧垃圾桶设备列表
import SmartTrashManagerInfo from './src/SmartTrashManager/SmartTrashManagerInfo.vue' //智慧垃圾桶设备详情

let views = {
    home,
    SmartTrashManagerView,
    SmartTrashManagerInfo
};

export default views;